<template>
  <authenticated-layout
    :back-route="{ name: 'vouchers' }"
    :breadcrumbs="breadcrumbItems">

    <AccessCodeDetailContent  @access-code-loaded="onAccessCodeLoaded" />

  </authenticated-layout>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {AccessCode} from "@YenzaCT/sdk";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import AccessCodeDetailContent from "@/components/AccessCodeDetail/AccessCodeDetailContent.vue";

const accessCode = ref<AccessCode>();

const breadcrumbItems = computed(() => [
  { text: "Licenses", to: { name: "vouchers" } },
  { text: accessCode.value?.code || "" }
]);

function onAccessCodeLoaded(loadedAccessCode: AccessCode) {
  accessCode.value = loadedAccessCode;
}
</script>
